export class Cell
{
	public readonly elem: HTMLElement;
	public readonly date: Date;
	public readonly time: number;
	private _cb: (cell: Cell) => void;
	private readonly _contentDiv: HTMLElement;

	constructor(
		public readonly y: number,
		public readonly m: number,
		public readonly d: number, // date
	)
	{
		this.date = new Date(y, m, d);
		Object.freeze(this.date);

		this.time = this.date.getTime();

		this.elem = document.createElement("td");
		this.elem.setAttribute("scope", "col");

		this._contentDiv = document.createElement("div");
		this.elem.append(this._contentDiv);
	}

	public initButton(cb: (cell: Cell) => void): void
	{
		this._cb = cb;
		this.elem.addEventListener("click", () => this.onClick());
	}

	public setInPast(): void
	{
		this.elem.classList.add("table-secondary");
	}

	public setAsDummy(): void
	{
		this.elem.classList.add("table-cell-dummy");
	}

	public showDate(): void
	{
		this.elem.classList.add("table-cell-date");
		this._contentDiv.innerText = this.d + "";
	}

	public clearReserves(): void
	{
		this.elem.classList.remove("cell-reserve-check-in");
		this.elem.classList.remove("cell-reserve-full");
		this.elem.classList.remove("cell-reserve-check-out");
	}

	public setReserveCheckIn(): void
	{
		this.elem.classList.add("cell-reserve-check-in");
	}

	public setReserveFull(): void
	{
		this.elem.classList.add("cell-reserve-full");
	}

	public setReserveCheckOut(): void
	{
		this.elem.classList.add("cell-reserve-check-out");
	}

	public setBookedCheckIn(): void
	{
		this.elem.classList.add("cell-booked-check-in");
	}

	public setBookedFull(): void
	{
		this.elem.classList.add("cell-booked-full");
	}

	public setBookedCheckOut(): void
	{
		this.elem.classList.add("cell-booked-check-out");
	}

	private onClick(): void
	{
		this._cb(this);
	}
}
